// extracted by mini-css-extract-plugin
module.exports = {"badge-summary":"_2d2dau-h-nxeJdu3cU0ZNW"};